import { compose } from '@reduxjs/toolkit';
import { withTranslation } from 'react-i18next';
import { ComponentType } from 'react';

import SetPasswordPage from './TermsOfService.layout';


const decorate = compose<ComponentType>(
    withTranslation('termsOfService'),
);

export default decorate(SetPasswordPage);
